import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Redux
import {
    getErrorState,
    getLoadingState,
    getCountriesState,
    dispatchCountriesFetch,
    getStatesState,
    dispatchStatesFetch,
    dispatchFundsFetch,
    getFundsState,
    getCurrentAddressState,
} from '../../../reducers/FoundationDonationReducer';

import { dispatchMemberSet } from '@react/redux/dispatch/memberDispatch';

// Components
import FoundationDonationForm from './FoundationDonationForm';
import LoadingOverlay from '@molecules/LoadingOverlay';
import { ErrorText, P, H1, Link } from '@styled';

// Helpers
import useViewer from '@hooks/useViewer';

const FoundationDonationContent = ({
    error,
    loading,
    currentAddress,
    fetchCountries,
    countries,
    states,
    funds,
    fetchStates,
    fetchFunds,
    setMember,
}) => {
    const [memberLoaded, setMemberLoaded] = useState(false);
    const { viewer } = useViewer();

    useEffect(() => {
        if (typeof viewer === 'undefined') {
            return;
        }

        setMemberLoaded(true);
        setMember(viewer);
    }, [viewer, setMember]);

    useEffect(() => {
        (async () => {
            fetchCountries();
            fetchStates();
            fetchFunds();
        })();
    }, [fetchCountries, fetchStates, fetchFunds]);

    return (
        <div>
            <H1>Foundation Donation</H1>
            <hr className="mt-3 mb-4" />
            {loading && <LoadingOverlay />}

            {error && error.includes('email') && (
                <>
                    <P className="mb-4">
                        <ErrorText>
                            An account already exists for this e-mail address. Please log in to continue.
                        </ErrorText>
                    </P>
                </>
            )}

            {error && !error.includes('email') && (
                <>
                    <P className="mb-4">
                        <ErrorText>Attention: {error}</ErrorText>
                    </P>
                </>
            )}

            {memberLoaded && (
                <FoundationDonationForm
                    countries={countries}
                    states={states}
                    funds={funds}
                    currentAddress={currentAddress}
                />
            )}

            <P className="mt-3">
                Questions? Please contact Toni Levi at{' '}
                <a className="cursor-pointer text-link" href="mailto:TLevi@icsc.com">
                    TLevi@icsc.com
                </a>{' '}
                or{' '}
                <a className="cursor-pointer text-link" href="tel:+6467283617">
                    (646) 728-3617
                </a>
                .
            </P>
        </div>
    );
};

FoundationDonationContent.propTypes = {
    currentAddress: PropTypes.object,
    countries: PropTypes.array,
    states: PropTypes.array,
    funds: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    setMember: PropTypes.func.isRequired,
    fetchCountries: PropTypes.func.isRequired,
    fetchStates: PropTypes.func.isRequired,
    fetchFunds: PropTypes.func.isRequired,
};

// -----------------------------
// Redux
// -----------------------------

const mapStateToProps = state => ({
    error: getErrorState(state),
    loading: getLoadingState(state),
    currentAddress: getCurrentAddressState(state),
    countries: getCountriesState(state),
    states: getStatesState(state),
    funds: getFundsState(state),
});

const mapDispatchToProps = dispatch => ({
    fetchCountries: () => dispatchCountriesFetch()(dispatch),
    fetchStates: () => dispatchStatesFetch()(dispatch),
    fetchFunds: () => dispatchFundsFetch()(dispatch),
    setMember: (...args) => dispatchMemberSet(...args)(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FoundationDonationContent);
